
export enum CircleStatus {
    NO = "no",
    INCORRECT = "incorrect",
    YES = "yes",
    CORRECT = "correct",
    PARTIAL = "partial"
}
